import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, AppleIcon, ClockIcon } from 'lucide-react';
const steps = [{
  icon: ShoppingCartIcon,
  text: 'Escanea la lista de "Stock Crítico" y haz tu compra rápida de la semana.'
}, {
  icon: AppleIcon,
  text: 'Aplica la Matriz 3-2-1 cada mañana (solo necesitas abrir contenedores y organizar).'
}, {
  icon: ClockIcon,
  text: 'Cierra la lonchera en 15 minutos y tómate tu café caliente mientras el resto de la casa despierta.'
}];
export function HowItWorks() {
  return <section className="bg-white py-24 px-6" data-id="element-107">
      <div className="max-w-5xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-109">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F]" data-id="element-110">
            Cómo funciona en la vida real
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-111">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-[#FFF8F0] z-0" data-id="element-112"></div>

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-113">
                <div className="w-24 h-24 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-6 shadow-sm border-4 border-white group-hover:scale-110 transition-transform duration-300" data-id="element-114">
                  <Icon size={36} className="text-[#E76F51]" data-id="element-115" />
                </div>
                <div className="bg-[#2D6A4F] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold absolute top-0 right-1/2 translate-x-10 shadow-md" data-id="element-116">
                  {index + 1}
                </div>
                <h3 className="font-heading text-xl font-bold text-[#2D6A4F] mb-3" data-id="element-117">
                  Paso {index + 1}
                </h3>
                <p className="text-[#5C4B3A] leading-relaxed px-4" data-id="element-118">
                  {step.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}